// feat_347 — Tab "Bandeja de entrada" de /Settings.
//
// 🔴 REGLA #1 DE ESTA PANTALLA: los 8 TabPanel quedan SIEMPRE MONTADOS (el shell
// los oculta con `hidden`, nunca los desmonta). 21 campos de texto guardan con
// `onBlur`; si al cambiar de tab React desmontara el input, el onBlur NO dispara
// y el usuario pierde lo tipeado sin ningún aviso. NO convertir esto en render
// condicional ni en lazy.
//
// Todo el estado vive en el padre (`Settings/index.js`) y llega por `ctx`.
// El JSX es un MOVIMIENTO VERBATIM de index.js — Fase 1 no cambia ni un pixel.

import React from "react";

import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Select from "@material-ui/core/Select";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";

import { i18n } from "../../../translate/i18n.js";

const TabBandeja = ({ ctx }) => {
	const {
		classes,
		saveSetting,
		inboxMode, setInboxMode,
		attendingMode, setAttendingMode,
		closedPooledMode, setClosedPooledMode,
		directResolve, setDirectResolve,
		showUserFilter, setShowUserFilter,
		markReadOnOpen, setMarkReadOnOpen,
		tdrYellowThreshold, setTdrYellowThreshold,
		tdrRedThreshold, setTdrRedThreshold,
	} = ctx;

	return (
		<>
				{/* feat_323: modo de bandeja — split (dos sub-tabs) vs unified (una lista).
				    Default "split" = comportamiento histórico; el setting es público
				    (SettingController.publicKeys) porque lo consume TODO perfil, no solo
				    el admin que lo configura acá. */}
				<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
					{i18n.t("settingsExtra.inboxModeSectionTitle")}
				</Typography>
				<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
					<FormControl style={{ minWidth: 280 }}>
						<InputLabel shrink>{i18n.t("settingsExtra.inboxModeLabel")}</InputLabel>
						<Select
							native
							value={inboxMode}
							onChange={async (e) => {
								const val = e.target.value;
								setInboxMode(val);
								await saveSetting("inboxMode", val);
							}}
						>
							<option value="split">{i18n.t("settingsExtra.inboxModeSplit")}</option>
							<option value="unified">{i18n.t("settingsExtra.inboxModeUnified")}</option>
							<option value="smart">{i18n.t("settingsExtra.inboxModeSmart")}</option>
						</Select>
					</FormControl>
					<Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 8 }}>
						{i18n.t("settingsExtra.inboxModeHelper")}
					</Typography>
				</Paper>

			{/* feat_295: EN ATENCIÓN POR <asesor> — indicador + soft-lock */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.attendingModeSectionTitle")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControl style={{ minWidth: 280 }}>
					<InputLabel shrink>{i18n.t("settingsExtra.attendingModeLabel")}</InputLabel>
					<Select
						native
						value={attendingMode}
						onChange={async (e) => {
							const val = e.target.value;
							setAttendingMode(val);
							await saveSetting("attendingMode", val);
						}}
					>
						<option value="off">{i18n.t("settingsExtra.attendingModeOff")}</option>
						<option value="visual">{i18n.t("settingsExtra.attendingModeVisual")}</option>
						<option value="lock">{i18n.t("settingsExtra.attendingModeLock")}</option>
					</Select>
				</FormControl>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 8 }}>
					{i18n.t("settingsExtra.attendingModeHelper")}
				</Typography>
			</Paper>

			{/* feat_338: pool de RESUELTOS — quién puede encontrar y tomar un cerrado */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.closedPooledSectionTitle")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControl style={{ minWidth: 280 }}>
					<InputLabel shrink>{i18n.t("settingsExtra.closedPooledLabel")}</InputLabel>
					<Select
						native
						value={closedPooledMode}
						onChange={async (e) => {
							const val = e.target.value;
							setClosedPooledMode(val);
							await saveSetting("closedTicketsPooledByQueue", val);
						}}
					>
						<option value="off">{i18n.t("settingsExtra.closedPooledOff")}</option>
						<option value="queue">{i18n.t("settingsExtra.closedPooledQueue")}</option>
						<option value="company">{i18n.t("settingsExtra.closedPooledCompany")}</option>
					</Select>
				</FormControl>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 8 }}>
					{i18n.t("settingsExtra.closedPooledHelper")}
				</Typography>
				{/* feat_339: el mismo rótulo de cada <option>, para que el admin lea la
				     explicación del modo que acaba de elegir con el texto que ya vio. */}
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginTop: 4 }}>
					<strong>{i18n.t("settingsExtra.closedPooledOff")}:</strong> {i18n.t("settingsExtra.closedPooledHelperOff")}
				</Typography>
				<Typography variant="caption" display="block" color="textSecondary">
					<strong>{i18n.t("settingsExtra.closedPooledQueue")}:</strong> {i18n.t("settingsExtra.closedPooledHelperQueue")}
				</Typography>
				<Typography variant="caption" display="block" color="textSecondary">
					<strong>{i18n.t("settingsExtra.closedPooledCompany")}:</strong> {i18n.t("settingsExtra.closedPooledHelperCompany")}
				</Typography>
			</Paper>

			{/* feat_343: Resolver directo — el botón Resolver (individual y en lote)
			     cierra sin el menú ganado/perdido y sin tocar el estado del contacto. */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.directResolveSectionTitle")}
			</Typography>
			<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
				<FormControlLabel
					control={
						<Switch
							checked={directResolve}
							onChange={async (e) => {
								const val = e.target.checked;
								setDirectResolve(val);
								await saveSetting("directResolve", val ? "true" : "false");
							}}
							color="primary"
						/>
					}
					label={i18n.t("settingsExtra.directResolveLabel")}
				/>
				<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
					{i18n.t("settingsExtra.directResolveHelper")}
				</Typography>
			</Paper>

				{/* feat_301: filtro por usuario en la bandeja (solo admins) */}
				<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
					{i18n.t("settingsExtra.showUserFilterSectionTitle")}
				</Typography>
				<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
					<FormControlLabel
						control={
							<Switch
								checked={showUserFilter}
								onChange={async (e) => {
									const val = e.target.checked;
									setShowUserFilter(val);
									await saveSetting("showUserFilter", val ? "true" : "false");
								}}
								color="primary"
							/>
						}
						label={i18n.t("settingsExtra.showUserFilterLabel")}
					/>
					<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
						{i18n.t("settingsExtra.showUserFilterHelper")}
					</Typography>
				</Paper>

			{/* markReadOnOpen: marcar leído al abrir el chat */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
					{i18n.t("settingsExtra.markReadOnOpenSectionTitle")}
				</Typography>
				<Paper className={classes.paper} style={{ flexDirection: "column", alignItems: "flex-start" }}>
					<FormControlLabel
						control={
							<Switch
								checked={markReadOnOpen}
								onChange={async (e) => {
									const val = e.target.checked;
									setMarkReadOnOpen(val);
									await saveSetting("markReadOnOpen", val ? "true" : "false");
								}}
								color="primary"
							/>
						}
						label={i18n.t("settingsExtra.markReadOnOpenLabel")}
					/>
					<Typography variant="caption" display="block" color="textSecondary" style={{ marginLeft: 46 }}>
						{i18n.t("settingsExtra.markReadOnOpenHelper")}
					</Typography>
				</Paper>

			{/* TDR Thresholds section */}
			<Typography variant="body2" className={classes.sectionTitle} gutterBottom>
				{i18n.t("settingsExtra.tdrTitle")}
			</Typography>
			<Paper style={{ padding: 16, marginBottom: 12 }}>
				<Typography variant="caption" color="textSecondary" display="block" gutterBottom>
					{i18n.t("settingsExtra.tdrDesc")}
				</Typography>
				<div style={{ display: "flex", flexDirection: "column", gap: 16, marginTop: 8 }}>
					<TextField
						label={i18n.t("settingsExtra.tdrAmarilla")}
						type="number"
						size="small"
						variant="outlined"
						value={tdrYellowThreshold}
						onChange={e => setTdrYellowThreshold(e.target.value)}
						onBlur={async () => { await saveSetting("tdrYellowThreshold", tdrYellowThreshold); }}
						inputProps={{ min: 1 }}
						style={{ maxWidth: 260 }}
						helperText={i18n.t("settingsExtra.tdrAmarillaDesc")}
					/>
					<TextField
						label={i18n.t("settingsExtra.tdrRoja")}
						type="number"
						size="small"
						variant="outlined"
						value={tdrRedThreshold}
						onChange={e => setTdrRedThreshold(e.target.value)}
						onBlur={async () => { await saveSetting("tdrRedThreshold", tdrRedThreshold); }}
						inputProps={{ min: 1 }}
						style={{ maxWidth: 260 }}
						helperText={i18n.t("settingsExtra.tdrRojaDesc")}
					/>
					{parseInt(tdrYellowThreshold, 10) >= parseInt(tdrRedThreshold, 10) && (
						<Typography variant="caption" style={{ color: "#e65100" }}>
							{i18n.t("settingsExtra.tdrWarning")}
						</Typography>
					)}
				</div>
			</Paper>
		</>
	);
};

export default TabBandeja;
